var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-app-bar',{attrs:{"filterable":"","filters":_vm.filters,"back-to":true}},[_vm._v(" "+_vm._s(_vm.isPromo ? 'Promoções' : 'Produtos')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }